import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import configureGraphQL from "./common/configureGraphQL";
import registerServiceWorker from "./registerServiceWorker";
import { ApolloProvider } from '@apollo/client';
import { App } from "./App";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const history = createBrowserHistory({ basename: baseUrl });

const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const client = configureGraphQL(store);

Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}

Array.prototype.groupBy = function (key) {
    return this.reduce(function (oldValue, currentValue) {
        (oldValue[currentValue[key]] = oldValue[currentValue[key]] || []).push(currentValue);
        return oldValue;
    },
        {});
};

String.prototype.toSeoUrl = function () {
    var url = this;
    // make the url lowercase         
    var encodedUrl = url.toString().toLowerCase();

    // replace & with and           
    encodedUrl = encodedUrl.split(/\&+/).join("-and-");

    // remove invalid characters 
    encodedUrl = encodedUrl.split(/[^a-z0-9]/).join("-");

    // remove duplicates 
    encodedUrl = encodedUrl.split(/-+/).join("-");

    // trim leading & trailing characters 
    encodedUrl = encodedUrl.trim("-");

    return encodedUrl;
}

Number.prototype.toMoney = function (needFraction = true) {
    var parts = this.toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${needFraction? parts.join(".") : parts[0]}`;
}

ReactDOM.render(
    <ApolloProvider client={client}>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
    </ApolloProvider>,
    document.getElementById("root")
);

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js